interface Icolors {
  transparent: 'rgba(0, 0, 0, 0)',
  greenDark: '#008749',
  greenDarkViveo: '#0E4C54',
  viveoDarkBlue: '#0E4C54',
  greenLight: '#16B96E',
  cyanLight: '#5ACDD3',
  cyanLightViveo: '#6EE4D9',
  blueDark: '#364863',
  viveoBlueText: '#364863',
  blueViveo: '#18A0FB',
  vpcGray: '#BEBEBE',

  red: '#F61155',
  mfRed: '#DE2248',

  yellow: '#E4AC15',

  black: '#000',
  white: '#FFF',

  gray1: '#858585',
  grayDark: '#898989',
  gray: '#BCBCBC',
  grayLight: '#EEEBE8',
  mfMediumGrey: '#9F9F9F',
  mfDarkGrey: '#656565',
  priceHistoryTableGrey: '#F2F2F2',
  primary: "#3b4887",
  "warning": "#d59b00",
  "danger": "#de2248",
  "alert": "#E02828",
  "whitesmoke": "#f2f2f2",
  "dg-white": "#fcfcfc",
  "blue": "#18a0fb",
  "black-50": "#0005",
  "title": "#3a3a3a",
  "dg-black": "#3a3a3a",
  "dark-gray": "#c4c4c4",
  "white-90": "#fff9",
  "gray-90": "rgba(251, 251, 251, 0.9)",
  "background": "#606060",
  "modal": "rgba(230, 230, 230, 0.9)",
  "dg-orange": "#e76800",
  "dg-blue": "#01366a",
  "dg-med-blue": "#326ea9",
  "dg-med-gray": "#c2c2c2",
  "secondary": "#ffa052",
  "blur": "rgba(255, 255, 255, 0.5)",
  "dg-dark-grey": "#656565",
  "dg-green": "#18d083",
  "dg-light-green": "#59E9AC",
  "dg-light-red": "#FF748D",
  "dg-light-grey": "#F0F0F0",
  "dg-light-orange": "#FFBF8B",
  "table-header": "#989898"
}


export const colors: Icolors = {
  transparent: 'rgba(0, 0, 0, 0)',
  greenDark: '#008749',
  greenDarkViveo: '#0E4C54',
  viveoDarkBlue: '#0E4C54',
  greenLight: '#16B96E',
  cyanLight: '#5ACDD3',
  cyanLightViveo: '#6EE4D9',
  blueDark: '#364863',
  viveoBlueText: '#364863',
  blueViveo: '#18A0FB',
  vpcGray: '#BEBEBE',

  red: '#F61155',
  mfRed: '#DE2248',


  yellow: '#E4AC15',

  black: '#000',
  white: '#FFF',

  gray1: '#858585',
  grayDark: '#898989',
  gray: '#BCBCBC',
  grayLight: '#EEEBE8',
  mfMediumGrey: '#9F9F9F',
  mfDarkGrey: '#656565',
  priceHistoryTableGrey: '#F2F2F2',

  "primary": "#3b4887",
  "warning": "#d59b00",
  "danger": "#de2248",
  "alert": "#E02828",

  "whitesmoke": "#f2f2f2",
  "dg-white": "#fcfcfc",
  "blue": "#18a0fb",
  "black-50": "#0005",
  "title": "#3a3a3a",
  "dg-black": "#3a3a3a",
  "dark-gray": "#c4c4c4",
  "white-90": "#fff9",
  "gray-90": "rgba(251, 251, 251, 0.9)",
  "background": "#606060",
  "modal": "rgba(230, 230, 230, 0.9)",
  "dg-orange": "#e76800",
  "dg-blue": "#01366a",
  "dg-med-blue": "#326ea9",
  "dg-med-gray": "#c2c2c2",
  "secondary": "#ffa052",
  "blur": "rgba(255, 255, 255, 0.5)",
  "dg-dark-grey": "#656565",
  "dg-green": "#18d083",
  "dg-light-green": "#59E9AC",
  "dg-light-red": "#FF748D",
  "dg-light-grey": "#F0F0F0",
  "dg-light-orange": "#FFBF8B",
  "table-header": "#989898"
}